import clsx from 'clsx'
import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import LinesTotal from './lines-total/LinesTotal'
import { BillingColumns } from '../BillingColumns'
import { DescriptionMode } from '../DescriptionMode'
import {
  ComputedPrice,
  PriceObjectOutputDto,
  TravelTypeEnum,
} from '../../../../../../lib/graphql'
import { useTravelTypeContext } from '../../../../../contexts'

interface IDetailsTotalProps {
  label?: string
  total: Pick<PriceObjectOutputDto, 'basePrice' | 'priceWithDiscount'>
  adults?: number
  className?: string
  depositAmount?: ComputedPrice | null
  balanceAmount?: ComputedPrice | null
  balancePostFinalAmount?: ComputedPrice | null
  descriptionMode?: DescriptionMode
  columns: BillingColumns[]
  extraTotal?: {
    label: string
    price?: ComputedPrice | null
    priceWithDiscount?: ComputedPrice | null
  }[]
  showAdjustments?: boolean
  noColor?: boolean
}

const DetailsTotal = ({
  label,
  total,
  adults,
  className,
  depositAmount,
  balanceAmount,
  balancePostFinalAmount,
  descriptionMode,
  columns,
  extraTotal,
  showAdjustments = false,
  noColor = false,
}: IDetailsTotalProps) => {
  const intl = useIntl()
  const { travelType } = useTravelTypeContext()

  return (
    <div
      className={clsx(s.blockContainer, className, { [s.colored]: !noColor })}
    >
      <LinesTotal
        label={label}
        price={total.basePrice}
        priceWithDiscount={total.priceWithDiscount}
        descriptionMode={descriptionMode}
        adults={adults}
        columns={columns}
        showAdjustments={showAdjustments}
      />
      {depositAmount && (
        <LinesTotal
          label={intl.formatMessage({
            id: 'ui.DetailsTotal.depositLabel',
            defaultMessage: 'acompte',
          })}
          price={depositAmount}
          descriptionMode={descriptionMode}
          adults={adults}
          columns={columns}
          showAdjustments={showAdjustments}
        />
      )}
      {balanceAmount && (
        <LinesTotal
          label={intl.formatMessage({
            id: 'ui.DetailsTotal.balanceLabel',
            defaultMessage: 'solde',
          })}
          price={balanceAmount}
          descriptionMode={descriptionMode}
          adults={adults}
          columns={columns}
          showAdjustments={showAdjustments}
        />
      )}
      {balancePostFinalAmount && (
        <LinesTotal
          label={
            travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT
              ? intl.formatMessage({
                  id: 'ui.DetailsTotal.balancePostFinalLabelEvent',
                  defaultMessage: 'solde après événement',
                })
              : intl.formatMessage({
                  id: 'ui.DetailsTotal.balancePostFinalLabel',
                  defaultMessage: 'solde après séjour',
                })
          }
          price={balancePostFinalAmount}
          descriptionMode={descriptionMode}
          adults={adults}
          columns={columns}
          showAdjustments={showAdjustments}
        />
      )}
      {extraTotal &&
        extraTotal.map((extraTotalItem, index) => (
          <LinesTotal
            key={index}
            label={extraTotalItem.label}
            price={extraTotalItem.price}
            priceWithDiscount={extraTotalItem.priceWithDiscount}
            descriptionMode={descriptionMode}
            adults={adults}
            columns={columns}
            showAdjustments={showAdjustments}
            isExtraTotal={true}
            className={s.regular}
          />
        ))}
    </div>
  )
}

export default DetailsTotal
